"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusUserStatus = exports.VerticalCategory = exports.BonusVertical = exports.BonusType = exports.BonusStatus = exports.BonusPaymentStatus = exports.CashbackPayoutStrategies = exports.BonusPeriod = void 0;
var BonusPeriod;
(function (BonusPeriod) {
    BonusPeriod["Day"] = "Day";
    BonusPeriod["Week"] = "Week";
    BonusPeriod["Month"] = "Month";
})(BonusPeriod || (exports.BonusPeriod = BonusPeriod = {}));
var CashbackPayoutStrategies;
(function (CashbackPayoutStrategies) {
    CashbackPayoutStrategies["profit"] = "profit";
    CashbackPayoutStrategies["turnover"] = "turnover";
    CashbackPayoutStrategies["loss"] = "loss";
})(CashbackPayoutStrategies || (exports.CashbackPayoutStrategies = CashbackPayoutStrategies = {}));
var BonusPaymentStatus;
(function (BonusPaymentStatus) {
    BonusPaymentStatus["Pending"] = "Pending";
    BonusPaymentStatus["Paid"] = "Paid";
    BonusPaymentStatus["Failed"] = "Failed";
    BonusPaymentStatus["Rollback"] = "Rollback";
})(BonusPaymentStatus || (exports.BonusPaymentStatus = BonusPaymentStatus = {}));
var BonusStatus;
(function (BonusStatus) {
    BonusStatus["Pending"] = "Pending";
    BonusStatus["Processing"] = "Processing";
    BonusStatus["Paid"] = "Paid";
    BonusStatus["Rollback"] = "Rollback";
    BonusStatus["Failed"] = "Failed";
})(BonusStatus || (exports.BonusStatus = BonusStatus = {}));
var BonusType;
(function (BonusType) {
    BonusType["Cashback"] = "Cashback";
    BonusType["Referral"] = "Referral";
    BonusType["Agent"] = "Agent";
    BonusType["Multibet"] = "Multibet";
})(BonusType || (exports.BonusType = BonusType = {}));
var BonusVertical;
(function (BonusVertical) {
    BonusVertical["Sport"] = "Sport";
    BonusVertical["Casino"] = "Casino";
    BonusVertical["LiveCasino"] = "LiveCasino";
    BonusVertical["CustomSport"] = "CustomSport";
    BonusVertical["CustomCasino"] = "CustomCasino";
    BonusVertical["CustomLiveCasino"] = "CustomLiveCasino";
})(BonusVertical || (exports.BonusVertical = BonusVertical = {}));
var VerticalCategory;
(function (VerticalCategory) {
    VerticalCategory["Prematch"] = "Prematch";
    VerticalCategory["Live"] = "Live";
    VerticalCategory["VirtualSports"] = "VirtualSports";
    VerticalCategory["ScratchCards"] = "ScratchCards";
    VerticalCategory["VideoSlots"] = "VideoSlots";
    VerticalCategory["TableGames"] = "TableGames";
    VerticalCategory["VideoBingo"] = "VideoBingo";
    VerticalCategory["VideoPoker"] = "VideoPoker";
    VerticalCategory["VirtualGames"] = "VirtualGames";
    VerticalCategory["LiveCasino"] = "LiveCasino";
    VerticalCategory["LiveCasinoTable"] = "LiveCasinoTable";
    VerticalCategory["Poker"] = "Poker";
})(VerticalCategory || (exports.VerticalCategory = VerticalCategory = {}));
var BonusUserStatus;
(function (BonusUserStatus) {
    BonusUserStatus["Created"] = "Created";
    BonusUserStatus["Captured"] = "Captured";
    BonusUserStatus["Error"] = "Error";
    BonusUserStatus["Cancelled"] = "Cancelled";
})(BonusUserStatus || (exports.BonusUserStatus = BonusUserStatus = {}));
//# sourceMappingURL=bonus.js.map